module.exports = __webpack_public_path__ + "img/salon_de_rozazyu.ede063da.jpg";